<template>

    <div class="limite-plan">
        <div class="text-center p-4" v-if="isLoading">
            <b-spinner class="loading-spinner" />
        </div>
        <b-card v-else :header="header" class="limite-plan">
            <b-form @submit.prevent="submitLimit" class="limite-plan-form">

                <b-input-group prepend="Plan:">
                    <b-form-input :value="cPlanName" disabled />
                </b-input-group>

                <b-input-group prepend="Vendidos:">
                    <b-form-input :value="planData.vendidos" disabled />
                </b-input-group>

                <b-input-group>
                    <template #prepend>
                        <b-button key="unlocked" v-if="limit === null"
                            @click="limit = (planData.vendidos + upperMargin); requireSave = true;">
                            <i class="fa fa-unlock"></i>
                        </b-button>
                        <b-button variant="warning" key="lock" v-else @click="limit = null; requireSave = true;">
                            <i class="fa fa-lock"></i>
                        </b-button>
                    </template>
                    <b-form-input v-if="limit"
                        type="number"
                        v-model.number="limit"
                        required
                        @change="requireSave = true;"
                        @keyup.enter="saveLimit"
                        :min="planData.vendidos"
                    />
                    <b-form-input v-else type="text" disabled value="Sin límite" />
                    <template #append>
                        <b-button v-if="isProcessing" disabled>
                            <i class="fa fa-cog fa-spin"></i>
                        </b-button>
                        <b-button v-else-if="requireSave" @click="saveLimit()">
                            <i class="fa fa-save"></i>
                        </b-button>
                        <b-input-group-text variant="default" v-else disabled>
                            <i class="fa fa-check"></i>
                        </b-input-group-text>
                    </template>
                </b-input-group>

                <!-- <b-button type="submit" variant="primary" :disabled="isLoading">
                <i class="fa fa-check"></i>
            </b-button> -->
            </b-form>
            <div class="debug" v-if="debug">
                {{ planData | json }}
            </div>
        </b-card>
    </div>

</template>

<script>
import axios from 'axios';
import _ from 'lodash';
import { notify } from '@/utils.js';
const emptyPlanData = {
    nombre: null,
    tipo: null,
    vendidos: 0
};
export default {
    name: "LimitePlan",
    props: {
        upperMargin: {
            type: Number,
            default: 2
        },
        header: {
            type: String,
            // default: 'Limite de Plan'
        },
        workingApi: {
            type: String,
            default: 'easylunchlimit/fetch'
        },
        savingApi: {
            type: String,
            default: 'easylunchlimit/save'
        },
        planId: {
            type: [String, Number],
            required: true
        },
        fecha: {
            type: String,
            required: true
        },
        debug: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        cPlanName() {
            return this.planData.nombre
                ? (this.planData.nombre + ' - ' + (this.planData.tipo === 'empresarial' ? 'Empresarial' : 'Escolar'))
                : '-';
        }
    },
    data() {
        return {
            isLoading: false,
            planData: _.clone(emptyPlanData),
            limit: null,
            requireSave: false,
            isProcessing: false
        };
    },
    methods: {
        getData() {
            return this.data;
        },
        async saveLimit() {
            this.isProcessing = true;
            try {
                const response = await axios.post(this.savingApi + '/' + this.planId + '/' + this.fecha, {
                    limit: this.limit
                });

                if(response.status){
                    this.$emit('updated');
                    this.requireSave = false;
                }
            } catch (e) {
                notify(e);
            } finally {
                this.isProcessing = false;
            }
        },
        async load() {
            this.isLoading = true;
            try {
                const response = await axios.get(this.workingApi + '/' + this.planId + '/' + this.fecha);

                if (response.status){
                    this.planData.nombre = response.data.plan;
                    this.planData.fecha = response.data.fecha;
                    this.planData.precio = response.data.precio;
                    this.planData.vendidos = response.data.cantidad;
                    this.limit              = response.data.limiteFecha;
                }

            } catch (e) {
                this.planData = _.clone(emptyPlanData);
                notify(e)
            } finally {
                this.isLoading = false;
            }
        }
    },
    async beforeMount() {
        await this.load();
    }
};
</script>

<style lang="scss">
.limite-plan {
    &-form {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 1rem;
        font-size: 0.8em;
    }
}
</style>